import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// * theme
import { ThemeProvider } from "@mui/material";
import atheticTheme from "./utils/athleticTheme";
import bodytechTheme from "./utils/bodytechTheme";

// routes
import { routes } from "./routes"

// * responsive
import withWidth from "@material-ui/core/withWidth";
import VersionApp from "./components/versionApp";

import './utils/i18n'

function App({ width }) {
  const [currentBrand, setCurrentBrand] = useState("1");

  const isMobile = width === "xs" || width === "sm";

  const currentPath = window.location.pathname + window.location.search;

  const props = {
    isMobile,
    setCurrentBrand,
    currentBrand
  }

  function removeScriptByName(name) {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.includes(name)) {
            scripts[i].parentNode.removeChild(scripts[i]);
            console.log("Script eliminado:", scripts[i].src);
        }
    }
  }

  useEffect(() => {
    window.addEventListener('load', () => {
      // Llama a la función para eliminar el script con nombre que comienza con "main."
      removeScriptByName("main.");
    });
  }, [])

  return (
    <ThemeProvider theme={['1', '3'].includes(currentBrand) ? bodytechTheme : atheticTheme}>
      <BrowserRouter>
        <Routes>
          {routes.map((route) => (
            <Route path={route.path} element={route.element(props)}/>
          ))}
          {/* {routes.filter(items => currentPath.startsWith(items.path) || items.path === '*').map((item) => {
            return <Route path={item.path} element={item.element(props)}/>
          })} */}
        </Routes>
      </BrowserRouter>
      <VersionApp />
    </ThemeProvider>
  );
}

export default withWidth()(App);
